<template>
  <div>
    <div class="box" v-for="(l, i) in log" :key="i">
      <b-card class="d-flex justify-content-between item-row products_list">
        <h4 class="list-group-item-heading">Exportação de pedidos para planilha</h4>
        <b-row>
          <b-col>
            <span><b> Ação realizada por: </b> {{ l.send_to_email }} </span>
            <span><b> Data: </b> {{ parseDate(l.created_at) }} </span><br />
            <CardLogStatus :log_status="getStatus(l.status, l)" />
          </b-col>
          <b-col class="text-right">
            <a
              v-if="hasExpired(l) && !!l.spreadsheet_links"
              class="icon"
              v-b-tooltip.hover
              @click.prevent="downloadSpreadsheet(l.spreadsheet_links)"
              :title="$t('Planilha Disponivel')"
            >
              <i class="fa fa-download" v-bind:class="{ expiredNo: expiredNo }"></i>
            </a>
            <span v-else>Planilha não disponivel</span>
          </b-col>
        </b-row>
      </b-card>
    </div>
  </div>
</template>

<script>
import CardLogStatus from "./CardLogStatus.vue";
import moment from 'moment-timezone';

export default {
  props: ["log"],
  components: { CardLogStatus },
  data() {
    return {
      expiredNo: true,
      statusMapping: [
        "Na fila de processamento",
        "Finalizado",
        "Erro ao processar",
        "Processando",
      ],
    };
  },
  methods: {
    getStatus(statusInt, obj) {
      const statusMapping = [
        {
          name: "Pendente",
          icon: "fa-spinner fa-pulse",
          badgeClass: "badge badge-secondary",
        },
        {
          name: "Planilha Enviada para o E-Mail",
          icon: "fa-check",
          badgeClass: "badge badge-success",
        },
        {
          name: "Erro ao processar",
          icon: "fa-exclamation-triangle",
          badgeClass: "badge badge-danger",
        },
        {
          name: "Processando",
          icon: "fa-spinner fa-pulse",
          badgeClass: "badge badge-info",
        },
      ];

      if (!this.hasExpired(obj)) {
        statusMapping[1] = {
          name: "Expirado",
          icon: "fa fa-hourglass-end",
          badgeClass: "badge badge-secondary",
        };
      }

      return statusInt <= statusMapping.length ? statusMapping[statusInt] : "Indefinido";
    },
    hasExpired(log) {
      const modified = log.created_at;
      if (modified) {
        const startDT = moment(modified);
        const endDT = moment();
        const hourDiff = endDT.diff(startDT, "hours");
        return Number(log.status) === 1 && hourDiff < 24;
      }
      return false;
    },
    downloadSpreadsheet(linksArr) {
      if (Array.isArray(linksArr)) {
        for (var i in linksArr) window.open(linksArr[i], "_blank").focus();
      } else {
        window.open(linksArr, "_blank").focus();
      }
    },
    parseDate(dateString) {
      if (typeof dateString === "string") {
        dateString = dateString.replace("T", " ");
        dateString = dateString.replace(".000Z", "");
        moment.locale();
        let datetime1 = moment.utc(dateString).tz("America/Sao_Paulo");
        return datetime1.format("DD/MM/YYYY HH:mm:SS");
      }
      return dateString;
    },
  },
};
</script>
<style scoped>
@keyframes shine {
  to {
    background-position:
      /*0 0,*/ 120% 0, /* move highlight to right */ 0 0;
  }
}
.spreadsheet-item-skeleton {
  position: relative;
  overflow: hidden;
  background-color: rgba(0, 0, 0, 0.12);
  cursor: wait;
  mask-image: radial-gradient(#fff, #000);
  height: 1rem;
  margin-bottom: 0.25rem;
  border-radius: 0.25rem;

  background-size: 20px 41px, /* highlight */ 100% 41px;

  background-position: 0 0, /* highlight */ 0 0;
}

.spreadsheet-item-skeleton-animate-wave:after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 0;
  background: linear-gradient(90deg, transparent, hsla(0, 0%, 100%, 0.4), transparent);
  animation: shine 1.75s linear infinite;
}

.btn-circle {
  border-radius: 50px;
  position: fixed;
  z-index: 10;
  bottom: 25px;
  right: 20px;
}

.btn i {
  vertical-align: 0px !important;
}

.border-marketplaces {
  padding: 13px 0px 10px 15px;
  border: solid 1px #ebebeb;
  font-size: 13px;
  min-height: 100%;
}

.border-marketplaces h2 {
  font-size: 15px;
  font-weight: 600;
}

.table th,
.table td {
  padding: 0.75rem;
  vertical-align: middle;
  text-align: center;
  border: 1px solid #dee2e6;
}

th,
td {
  padding: 15px;
  text-align: left;
}

.text-green {
  color: #187412;
}

.table {
  margin-top: 10px;
}

.item-row {
  margin: 0px 10px 10px 0px;
  cursor: default;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border: 1px solid rgb(235, 235, 235);
  padding: 15px;
  border-radius: 3px;
  background: #fff;
}

.item-row:hover {
  box-shadow: 3px 3px 25px #d4d4d4;
}

small,
.small {
  font-size: 95%;
  font-weight: 400;
}

h4 {
  font-size: 1rem;
}

.action-buttons a {
  margin: 0 3px;
  font-size: 20px;
}
.expiredNo {
  color: #187412;
}
.box {
  position: relative;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  width: 100%;
  font-size: 13px;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/Orders_v2/Aggregates/Exportacao/CardLogExportacao.vue